import React from 'react';
import { cn } from '@/utils';

export type ResultTabType = 'pending' | 'rollback';

interface ResultTabsProps {
  value: ResultTabType;
  onChange: (value: ResultTabType) => void;
}

const ResultTabs: React.FC<ResultTabsProps> = ({ value, onChange }) => {
  return (
    <div className="inline-flex rounded-md border border-green-500 bg-white shadow-lg p-1.5 my-2">
      <button
        onClick={() => onChange('pending')}
        className={cn(
          'px-4 py-1.5 text-sm font-medium rounded-md transition-all',
          value === 'pending' ? 'bg-primary/40 text-black shadow' : 'text-black'
        )}
      >
        Pending Results
      </button>

      <button
        onClick={() => onChange('rollback')}
        className={cn(
          'px-4 py-1.5 text-sm font-medium rounded-md transition-all',
          value === 'rollback' ? 'bg-primary/40 text-black shadow' : 'text-black'
        )}
      >
        Rollback Results
      </button>
    </div>
  );
};

export default ResultTabs;
